import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  IconButton
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export default function EditProductModal({ open, onClose, data }) {
  const [formData, setFormData] = useState({
    company_name: '',
    email_address: '',
    office_address: ''
  });
  useEffect(() => {
    if (data) setFormData({ ...data });
  }, [data]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle
        sx={{
          bgcolor: '#3F90DF',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Edit Product Information
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: '#161C24', pt: 4 }}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Company Name"
              value={formData.company_name}
              sx={{ input: { color: '#fff' }, '& label': { color: '#9CA3AF' } }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email Address"
              value={formData.email_address}
              sx={{ input: { color: '#fff' }, '& label': { color: '#9CA3AF' } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Office Address"
              value={formData.office_address}
              sx={{ input: { color: '#fff' }, '& label': { color: '#9CA3AF' } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ bgcolor: '#161C24', p: 3, borderTop: '1px solid #333' }}>
        <Button onClick={onClose} sx={{ color: '#fff' }}>
          Cancel
        </Button>
        <Button variant="contained" sx={{ bgcolor: '#3F90DF' }}>
          Update Product
        </Button>
      </DialogActions>
    </Dialog>
  );
}
